/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskApiAppCoreModelsScansForm990ScheduleAMinimumAssetAmountAverageMonthlyFMVOfSec
 */
export interface ExecRiskApiAppCoreModelsScansForm990ScheduleAMinimumAssetAmountAverageMonthlyFMVOfSec {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleAMinimumAssetAmountAverageMonthlyFMVOfSec
     */
    current_year_amt?: number;
}

/**
 * Check if a given object implements the ExecRiskApiAppCoreModelsScansForm990ScheduleAMinimumAssetAmountAverageMonthlyFMVOfSec interface.
 */
export function instanceOfExecRiskApiAppCoreModelsScansForm990ScheduleAMinimumAssetAmountAverageMonthlyFMVOfSec(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskApiAppCoreModelsScansForm990ScheduleAMinimumAssetAmountAverageMonthlyFMVOfSecFromJSON(json: any): ExecRiskApiAppCoreModelsScansForm990ScheduleAMinimumAssetAmountAverageMonthlyFMVOfSec {
    return ExecRiskApiAppCoreModelsScansForm990ScheduleAMinimumAssetAmountAverageMonthlyFMVOfSecFromJSONTyped(json, false);
}

export function ExecRiskApiAppCoreModelsScansForm990ScheduleAMinimumAssetAmountAverageMonthlyFMVOfSecFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskApiAppCoreModelsScansForm990ScheduleAMinimumAssetAmountAverageMonthlyFMVOfSec {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'current_year_amt': !exists(json, 'current_year_amt') ? undefined : json['current_year_amt'],
    };
}

export function ExecRiskApiAppCoreModelsScansForm990ScheduleAMinimumAssetAmountAverageMonthlyFMVOfSecToJSON(value?: ExecRiskApiAppCoreModelsScansForm990ScheduleAMinimumAssetAmountAverageMonthlyFMVOfSec | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'current_year_amt': value.current_year_amt,
    };
}

